import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { GrayBadge } from '@PipelineDeals/shared-react-components'
import copyToClipboard from 'modules/copyToClipboard'

const Container = styled.div`
  cursor: pointer;
  width: max-content;
`

const IdPrefix = styled.span`
  margin-right: 2px;

  @media (max-width: 1200px) {
    display: none;
  }
`

const IdBadge = ({ id }) => {
  const { t } = useTranslation()
  const handleClick = () => {
    copyToClipboard(id, t('profiles.notifications.idCopiedToClipboard'))
  }

  return (
    <Container onClick={handleClick}>
      <GrayBadge
        content={<><IdPrefix>{t('profiles.idPrefix')} </IdPrefix>{id}</>}
        trailingContent={<i className="far fa-copy" />}
      />
    </Container>
  )
}

IdBadge.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
}

export default IdBadge
